<template>
    <div class="order-list" :class="{mt_80: props.margin}">
        <div class="order-list__title-box">
            <h2 class="order-list__title">Корзина</h2>
            <button-component class="order-list__delete" button-text="Очистить" />
        </div>
        <div class="order-list__switch">
            <button-component class="order-list__switcher active" button-text="Все заказы" />
            <button-component class="order-list__switcher" button-text="Благоустройство могилы" />
            <button-component class="order-list__switcher" button-text="Памятник" />
        </div>
        <div class="order-list__search-input tablet">
            <input type="text" placeholder="Поиск">
        </div>
        <ul class="order-list__list">
            <li class="order-list__item" v-for="(order, index) in quantityOrders" :key="index">
                <div class="order-list__content">
                    <span class="order-list__text order-list__index">№{{index + 1}}</span>
                    <span class="order-list__text order-list__name">{{order?.information.deceased}}</span>
                    <span class="order-list__text order-list__text_gray order-list__type">{{order.type}}</span>
                    <span class="order-list__text order-list__status"
                    :class="order.status === 'Обработка' ? 'processing' :
                    order.status === 'В работе' ? 'inWork' :
                    order.status === 'Оплачен' ? 'paid' :
                    order.status === 'Сделан' ? 'done' :
                    order.status === 'Закрыт' ? 'closed' :
                    order.status === 'Отказ' ? 'refused' : ''
                    ">{{ order.status }}</span>
                    <span class="order-list__text order-list__price">{{ order.price.final }} &#8381;</span>
                </div>
                <div class="order-list__action-box">
                    <VDropdown>
                        <button class="order-list__action">
                            <icon-component class="order-list__icon" name="action" width="22" height="22"/>
                        </button>
                        <template #popper>
                          <div class="order-list__option-box">
                            <router-link :to="`/order/${order._id}`" class="order-list__option">Подробнее</router-link>
                            <button class="order-list__option">Восстановить</button>
                            <button class="order-list__option error">Удалить полностью</button>
                          </div>
                        </template>
                    </VDropdown>
                </div>
            </li>
        </ul>
    </div>
    <pagination></pagination>
</template>
<script setup lang="ts">
import axios from '../../app/lib/api'
import { Order, OrderStatus } from '../../app/lib/types/orders'
import iconComponent from '../../shared/iconComponent.vue'
import buttonComponent from '../../shared/buttonComponent.vue'
import pagination from '../../shared/pagination.vue'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import { onMounted, ref, watch } from 'vue'
import toast from '../../app/lib/hooks/errorToast'
import {useLoadingStore} from '../../app/store/store'
dayjs.extend(isBetween)

const props = defineProps({
    margin: {
        type: Boolean
    },
    link: {
        type: Boolean
    },
    sorting: {
        type: Boolean
    },
    date: {
        type: Array
    },
    filtered: {
        type: Boolean
    },
    quantity: {
        type: Number
    }
})
const loading = useLoadingStore()
const orders = ref([] as unknown as Order[])
const sortOrders = ref([] as unknown as Order[])
const filteredOrders = ref([] as unknown as Order[])
const upOrders = ref(true)
const quantityOrders = ref([] as unknown as Order[])

function setQuantityOrders() {
    if (props.quantity) {
        quantityOrders.value = filteredOrders.value.slice(0, props.quantity)
    } else {
        quantityOrders.value = filteredOrders.value
    }
}

const sortingOrders = () => {
    upOrders.value = !upOrders.value
    if(upOrders) {
        sortOrders.value.reverse()
    } else {
        sortOrders.value = orders.value
    }
}

watch(() => [props.date, upOrders], () => {
    if(props.filtered == true ) {
        //@ts-ignore
        filteredOrders.value = sortOrders.value.filter( item => dayjs(item.createdAt).isBetween(props.date[0], props.date[[props.date.length - 1]], 'day', []))
    } else {
        filteredOrders.value = sortOrders.value
    }
    setQuantityOrders()
},
{ deep: true })

onMounted(() => {
    loading.loading()
    let filter = {
        useTableMap: false,
        perPage: 0,
        sortBy: 'createdAt',
        sortOrder: 'desc',
        pageOffset: 0,
    }
    axios.order.getOrderList(filter)
    .then((res: any) => {
        orders.value = res.data.result.filter((order: Order) => order.status == OrderStatus.archive)
        sortOrders.value = orders.value
        sortingOrders()
        filteredOrders.value = sortOrders.value
        setQuantityOrders()
        loading.load()
    })
    .catch((err: any) => {
        loading.load()
        toast('error', "Не удалось загрузить заказы")
    })
})
</script>